const getRuntimeEnvironment = () =>
    process.env.SXM_ENV || process.env.npm_config_env || process.env.NEXT_PUBLIC_ENV || 'sandbox.preview';

export const shouldLoadLegacyCareScriptsForEnvironment = (environmentName?: string) => {
    const environment = environmentName?.toLowerCase() || '';

    return environment.startsWith('sit') || environment.includes('prod');
};

export const shouldLoadLegacyCareScripts = () => {
    return shouldLoadLegacyCareScriptsForEnvironment(getRuntimeEnvironment());
};
